import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { AsmStatePersistenceService } from '@spartacus/asm/core';
import { AsmAuthHttpHeaderService, AsmAuthService, AsmAuthStorageService } from '@spartacus/asm/root';
import { AuthHttpHeaderService, AuthService, AuthStorageService } from '@spartacus/core';
import { provideDefaultConfig } from '../../../core/config/config-providers';
import { AsmLoaderModule } from './asm-loader.module';
import { defaultAsmConfig } from './config/default-asm-config';
import { AsmBlockInvalidRequestInterceptor } from './interceptors';

export function asmStatePersistenceFactory(asmStatePersistenceService: AsmStatePersistenceService) {
  const result = () => asmStatePersistenceService.initSync();
  return result;
}

@NgModule({
  imports: [AsmLoaderModule],
  providers: [
    provideDefaultConfig(defaultAsmConfig),
    {
      provide: AuthStorageService,
      useExisting: AsmAuthStorageService,
    },
    {
      provide: AuthService,
      useExisting: AsmAuthService,
    },
    {
      provide: AuthHttpHeaderService,
      useExisting: AsmAuthHttpHeaderService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AsmBlockInvalidRequestInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = asmStatePersistenceFactory(inject(AsmStatePersistenceService));
      return initializerFn();
    }),
  ],
})
export class AsmRootModule {}
